import { Icon, InputGroup, Intent } from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import IconRequired from 'components/elements/required-icon';
import { get } from 'lodash';
import Permissions from 'react-redux-permissions';
import { createForm } from 'rc-form';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import styled from 'styled-components';
import NumberInput from 'rc-input-number';
import { IconNames } from '@blueprintjs/icons';
import PropTypes from 'prop-types';
import { SELECT_ITEM_DEFAULT } from 'config';

import QuanHuyenSelect from 'components/elements/select-quan-huyen';
import PhuongXaSelect from 'components/elements/select-phuong-xa';
import { COLOR } from 'config';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const FIELDS = {
  Area: 'Area',
  District: 'District',
  Wards: 'Wards',
  Lat: 'Lat',
  Lng: 'Lng',
  Square: 'Square',
  Quantity: 'Quantity',
};

const LABELS = {
  Area: 'Vùng phân bố',
  District: 'Quận/Huyện',
  Wards: 'Phường/Xã',
  Lat: 'Vĩ độ (°)',
  Lng: 'Kinh độ (°)',
  Square: 'Diện tích',
  Quantity: 'Số lượng cá thể',
};

const FormItem = (props) => {
  const { form, name, label, children, required } = props;
  const { getFieldError } = form || {};

  return (
    <div>
      <Row>
        <Col xs={4}>
          <LabelContainer>
            {label}
            {required ? <IconRequired /> : null}
          </LabelContainer>
        </Col>
        <Col xs={4}>
          {children}

          <ErrorContainer>
            {typeof getFieldError === 'function'
              ? (getFieldError(name) || []).join(', ')
              : null}
          </ErrorContainer>
        </Col>
      </Row>
      <Clearfix height={16} />
    </div>
  );
};

const SpeciesForm = (props) => {
  const [isEdit, setIsEdit] = useState(false);

  const { form, initialValue, handleSubmit } = props;
  const { getFieldProps, setFieldsValue, getFieldValue } = form;

  useEffect(() => {
    form.setFieldsValue({});
  }, [initialValue]);

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!values) return;

      const params = {
        Area: get(values, 'Area'),
        District: get(values, 'District.value'),
        Wards: get(values, 'Wards.value'),
        Lat: get(values, 'Lat'),
        Lng: get(values, 'Lng'),
        Square: get(values, 'Square'),
        Quantity: get(values, 'Quantity'),
      };
      await handleSubmit(params);
      setIsEdit(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <div>
        <h3 style={{ color: COLOR.PRIMARY_COLOR }} className='bp3-heading'>
          Vùng phân bố
        </h3>
      </div>
      <HeaderContainer>
        <Permissions allowed={[`biodiversity.write`]}>
          <div style={{ display: 'inline-flex' }}>
            {!isEdit && (
              <Icon
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                icon={IconNames.ADD}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
                onClick={() => setIsEdit(true)}
              />
            )}
            {isEdit && (
              <div style={{ display: 'inline-flex' }}>
                <Icon
                  style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                  icon={IconNames.SAVED}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.PRIMARY}
                  onClick={onSubmit}
                />
                <Clearfix width={8} />
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.DISABLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={() => setIsEdit(false)}
                />
              </div>
            )}
          </div>
        </Permissions>
      </HeaderContainer>

      {isEdit && (
        <div>
          <FormItem required label={LABELS.Area} form={form} name={FIELDS.Area}>
            <InputGroup
              placeholder={LABELS.Area}
              {...getFieldProps(FIELDS.Area, {
                rules: [
                  {
                    required: true,
                    message: 'Bắt buộc nhập vùng phân bố',
                  },
                ],
              })}
            />
          </FormItem>
          <FormItem label={LABELS.District} form={form} name={FIELDS.District}>
            <QuanHuyenSelect
              hideLabel
              fieldForm={{
                form,
                name: FIELDS.District,
                option: {
                  onChange: () => {
                    setFieldsValue({
                      [FIELDS.Wards]: SELECT_ITEM_DEFAULT,
                    });
                  },
                },
              }}
            />
          </FormItem>
          <FormItem label={LABELS.Wards}>
            <PhuongXaSelect
              hideLabel
              quanHuyenTarget={
                getFieldValue(FIELDS.District)
                  ? getFieldValue(FIELDS.District).value
                  : null
              }
              fieldForm={{
                form,
                name: FIELDS.Wards,
              }}
            />
          </FormItem>
          <FormItem label={LABELS.Lat} name={FIELDS.Lat}>
            <NumberInput min={-90} max={90} {...getFieldProps(FIELDS.Lat)} />
          </FormItem>
          <FormItem label={LABELS.Lng} name={FIELDS.Lng}>
            <NumberInput min={0} max={360} {...getFieldProps(FIELDS.Lng)} />
          </FormItem>
          <FormItem label={LABELS.Square} name={FIELDS.Square}>
            <InputGroup
              placeholder={LABELS.Square}
              {...getFieldProps(FIELDS.Square)}
            />
          </FormItem>
          <FormItem label={LABELS.Quantity} name={FIELDS.Quantity}>
            <InputGroup
              placeholder={LABELS.Quantity}
              {...getFieldProps(FIELDS.Quantity)}
            />
          </FormItem>
        </div>
      )}
    </div>
  );
};

export default createForm()(SpeciesForm);

SpeciesForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

SpeciesForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/AreaManagement/AreaForm/index.js